export const BASE_URL = "/api";
// export const BASE_URL = "https://koflip.com/api";
